export default __webpack_public_path__ + "static/media/pakrap-4.faa10036.mp3";